/* eslint-disable @typescript-eslint/no-explicit-any */
export function createLink(path) {
    return path
        .map((p) => p.replace(/\/\*/, '/'))
        .join('/')
        .replace(/\/\/+/g, '/')
        .replace(/\/+$/, '');
}
function pathMatches(fullPagePath, subPath, index, routePath) {
    if (subPath.endsWith('/') && !fullPagePath.endsWith('/')) {
        fullPagePath += '/';
    }
    if (fullPagePath === subPath) {
        return true;
    }
    if (routePath && routePath.indexOf(':') > -1) {
        const pathRegex = new RegExp(routePath.replace(/:[\w*]+/g, '.*'));
        if (pathRegex.test(fullPagePath)) {
            return true;
        }
    }
    if (!index && fullPagePath.startsWith(subPath)) {
        return true;
    }
    return false;
}
export function mapRoutesToItemsAndFindSelected(fullPagePath, routes, routeToItem) {
    const items = [];
    let selectedId = undefined;
    const forEachRouteRecursive = (routes) => {
        for (const route of routes) {
            const item = routeToItem(route);
            if (item) {
                items.push(item);
                if (item.base != null && pathMatches(fullPagePath, item.base, route.index, route.path)) {
                    if (route.path != null || selectedId == null) {
                        selectedId = item.id;
                    }
                }
            }
            else if (route.children) {
                forEachRouteRecursive(route.children);
            }
        }
    };
    forEachRouteRecursive(routes);
    return [items, selectedId];
}
export function navigateToCallback(navigationContext, navigate, navigateTo, onClick) {
    if (onClick) {
        return () => navigationContext.navigate(() => onClick(navigate));
    }
    else if (navigateTo != null) {
        return () => navigationContext.navigate(() => navigate(navigateTo));
    }
    else {
        return undefined;
    }
}
